import { useLocalSearchParams } from 'expo-router';

import { LibraryChatScreen } from '@/components/libraryChat/LibraryChatScreen';

/**
 * A saved conversation. Keyed by id so moving between conversations remounts
 * the screen and nothing from the previous one (scroll, draft, measured turn
 * heights) carries over.
 */
export default function AskConversationRoute() {
  const { conversationId } = useLocalSearchParams<{ conversationId: string }>();

  return <LibraryChatScreen key={conversationId} conversationId={conversationId} isNew={false} />;
}
